import { Dialog, DialogContent } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { OpenModal } from '../../../redux/Common/action';
import { SESSIONS_MODAL } from '../../../redux/ModalReducer/actionTypes';
import { RootState } from '../../../redux/store';
import {
    HarmonisedDialogTitle,
    HarmonisedModalActions
} from '../../Common/UI';
import UsersSessions from '../UsersSessions';

const SessionsModal = ({ OpenModal }) => {
    const modal: any =
        useSelector((store: RootState) => store?.modal?.sessionsModal) || {};

    const handleClose = () => {
        OpenModal(SESSIONS_MODAL, { isOpen: false });
    };

    return (
        <Dialog
            className="w-100"
            maxWidth={'lg'}
            fullWidth={modal?.config?.fullWidth || true}
            open={modal?.isOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <HarmonisedDialogTitle onClose={handleClose}>
                {modal?.title}
            </HarmonisedDialogTitle>
            <DialogContent>
                <UsersSessions
                    user_id={modal?.data?.selectedUser?.user_id}
                    isAdmin={modal?.data?.isAdmin}
                />
            </DialogContent>
            <HarmonisedModalActions
                onCancel={handleClose}
                cancelLabel="Close"
            />
        </Dialog>
    );
};

export default connect(null, {
    OpenModal
})(SessionsModal);
